import React from 'react';
import { useDispatch } from 'react-redux';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { getYear, getMonth, getDate, parseISO } from 'date-fns';

import SquareModal from '../_composedBlocks/SquareModal';
import DateInput from '../../DateInput';

import { authUserOperations } from '@evdy/web-redux/dist/lib/authUser';

import whiteChevron from '../../../public/images/icons/white-chevron-right.svg';

import styles from './EditBirthdayModal.module.scss';

const { updateUserBirthday } = authUserOperations || {};

const {
  'edit-birthday-modal-body': editBirthdayModalBodyClass,
  'update-button': updateButtonClass,
  'cancel-button': cancelButtonClass
} = styles;

const EditBirthdayModal = ({ closeModal, modalVisible, userData }) => {
  const dispatch = useDispatch();
  const handleUpdate = values => {
    const { userInfo } = userData?.preneed;
    dispatch(updateUserBirthday({ userInfo, values }));
  };

  const { dateOfBirth } = userData?.preneed?.userInfo ?? {};
  const parsedDOB = dateOfBirth && parseISO(dateOfBirth);
  const initialValues = parsedDOB
    ? {
        birthMonth: getMonth(parsedDOB) + 1, // month is zero-indexed, so add 1 to match standard month numbers,
        birthDay: getDate(parsedDOB),
        birthYear: getYear(parsedDOB)
      }
    : { birthMonth: '', birthDay: '', birthYear: '' };

  const validationSchema = Yup.object().shape({
    birthMonth: Yup.number()
      .typeError('Enter valid number')
      .min(1, 'Enter valid month')
      .max(12, 'Enter valid month')
      .required('Month is required!'),
    birthDay: Yup.number()
      .typeError('Enter valid number')
      .min(1, 'Enter a valid day')
      .max(31, 'Enter a valid day')
      .required('Day is required!'),
    birthYear: Yup.number()
      .typeError('Enter valid number')
      .min(1880, 'Enter a valid year')
      .max(new Date().getFullYear(), 'Enter a valid year')
      .required('Year is required!')
  });

  const birthDateInputProps = {
    label: 'Birthday',
    monthName: 'birthMonth',
    monthPlaceholder: 'MM',
    dayName: 'birthDay',
    dayPlaceholder: 'DD',
    yearName: 'birthYear',
    yearPlaceholder: 'YYYY'
  };

  return (
    <SquareModal {...{ closeModal, modalVisible }}>
      <Formik
        onSubmit={handleUpdate}
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        validateOnMount
      >
        {({ isValid, handleSubmit }) => (
          <div className={editBirthdayModalBodyClass}>
            <h3>Edit your birthday</h3>
            <h6>
              Changing your birthday will change insurance pricing. <br />
              Are you sure you want to update?
            </h6>
            <Form>
              <DateInput {...birthDateInputProps} />
            </Form>
            <button
              type="submit"
              className={updateButtonClass}
              disabled={!isValid}
              onClick={handleSubmit}
            >
              Update Birthday <img src={whiteChevron} alt="submit update" />
            </button>
            <button type="button" className={cancelButtonClass} onClick={closeModal}>
              Cancel
            </button>
          </div>
        )}
      </Formik>
    </SquareModal>
  );
};

export default EditBirthdayModal;
